/* eslint-disable @typescript-eslint/no-explicit-any */
import { types, Instance, flow } from 'mobx-state-tree';
import { AxiosResponse } from 'axios';
import axios from 'server';
import { IDepartmentUserModel, DepartmentUserModel, ManagerModel, IManagerModel } from './models/departmentUser.model';
import { UserDepartmentsView, UserDepartmentData } from './types';
const { model, array, maybeNull, reference, string } = types;

export const DepartmentUserTableStore = model('GroupTableStore', {
  userDepartment: array(DepartmentUserModel),
  managerDepartment: array(ManagerModel),
  filter: string,
  clickedDepartmentUser: maybeNull(reference(DepartmentUserModel)),
})
  .views((self) => ({
    get userDepartmentsView(): UserDepartmentsView[] {
      if (!self.userDepartment || self.userDepartment.length === 0) {
        return [];
      }
      const usersView: UserDepartmentsView[] = [];
      for (let i = 0; i < self.userDepartment.length; i++) {
        const userDepartmentItem = self.userDepartment[i];
        const userView: UserDepartmentsView = { ...userDepartmentItem, id: i };
        usersView.push(userView);
      }
      if (!self.filter) {
        return usersView;
      }
      const regexp = new RegExp(self.filter, 'i');
      const filteredUserGroupsView = usersView.filter(({ mail, sn, uid, givenname }) =>
        regexp.test(`${mail}${sn}${uid}${givenname}`)
      );
      return filteredUserGroupsView;
    },
    get CurrentClickedUser() {
      return self.clickedDepartmentUser;
    },
  }))
  .actions((self) => ({
    clearClickedUser() {
      self.clickedDepartmentUser = null;
    },
  }))
  .actions((self) => ({
    normalizeuserGroup({ data }: AxiosResponse): IDepartmentUserModel[] {
      self.userDepartment.replace(data.data);
      return self.userDepartment;
    },

    normalizemanagerGroup({ data }: AxiosResponse): IManagerModel[] {
      self.managerDepartment.replace(data.group);
      return self.managerDepartment;
    },
    setFilter(filter: string) {
      self.filter = filter;
    },
    setClickedUser(dn: string): void {
      self.clickedDepartmentUser = self.userDepartment.find((user) => user.dn === dn) || null;
    },

    clearSelected(): void {
      self.clickedDepartmentUser = null;
    },
  }))
  .actions((self) => ({
    createUserDepartment: flow(function* (data: UserDepartmentData, dn) {
      const result = yield axios
        .post<IDepartmentUserModel>(`departments/${dn}/users`, data)
        .then(self.clearSelected)
        .catch((error) => {
          throw new Error(error);
        });
      return result;
    }),
    // getManagerGroup: flow(function* (dn) {
    //   try {
    //     const response = yield axios.get(`/groups/${dn}`);
    //     const group = response.data.data;
    //     const managers = group.managers ?? [];
    //     self.managerGroup.replace(managers);
    //     return managers;
    //   } catch (error: any) {
    //     throw new Error(error.response?.data?.message || error.message);
    //   }
    // }),
    getManagerDepartment: flow(function* (dn) {
      try {
        const response = yield axios.get(`/department/${dn}`);
        const department = response.data.data;
        const managers = department.managers ?? [];
        self.managerDepartment.replace(managers);
        return managers;
      } catch (error: any) {
        throw new Error(error.response?.data?.message || error.message);
      }
    }),
  }));
export type IDepartmentUserTableStore = Instance<typeof DepartmentUserTableStore>;
